import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { IDS, RoleId } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const getDataAll = async () => {
    const response = await getData(
      `/admin/products/product-stock?page=${onPageChange || 1}&per_page=${
        perPage || 5
      }&term=${search || ""}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(
      `/admin/products/product-stock/${id}`,
    );
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/admin/products/product-stock/${recordToDeleteId}`,
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    // col9: true,
  });

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  console.log(selectedItem, "selectedItem selectedItem");

  const [appsetup, setAppsetup] = useState([]);
  const GetAllCategory = async () => {
    const response = await getData("/common/masters/app-setup");
    if (response?.success) {
      setAppsetup(response?.data);
    }
  };

  useEffect(() => {
    GetAllCategory();
  }, []);

  const renderVariantName = (variant) => {
    // SINGLE
    if (!variant?.Double_Variants?.length) {
      return (
        <>
          <strong>Metal:</strong> {variant?.Metal?.name || "-"}
        </>
      );
    }

    return variant.Double_Variants.map((doubleVar, dIdx) => {
      // DOUBLE
      if (!doubleVar?.Triple_Variants?.length) {
        return (
          <div key={dIdx}>
            <strong>Size:</strong> {doubleVar?.Size?.name},{" "}
            <strong>Metal:</strong> {variant?.Metal?.name}
          </div>
        );
      }

      // TRIPLE
      return doubleVar.Triple_Variants.map((tripleVar, tIdx) => (
        <div key={`${dIdx}-${tIdx}`}>
          <strong>Diamond:</strong> {tripleVar?.Diamond?.name},{" "}
          <strong>Size:</strong> {doubleVar?.Size?.name},{" "}
          <strong>Metal:</strong> {variant?.Metal?.name}
        </div>
      ));
    });
  };

  const renderVariantStock = (variant, lowStockLimit) => {
    // SINGLE STOCK
    if (!variant?.Double_Variants?.length) {
      const stock = Number(variant?.general_stock || 0);

      return (
        <>
          {stock}
          {stock === 0 ? (
            <span className="text-danger ms-2 fw-bold">(No Stock)</span>
          ) : stock < lowStockLimit ? (
            <span className="text-warning ms-2 fw-bold">(Low Stock)</span>
          ) : null}
        </>
      );
    }

    // DOUBLE / TRIPLE STOCK
    return variant.Double_Variants.map((doubleVar, dIdx) => {
      // DOUBLE
      if (!doubleVar?.Triple_Variants?.length) {
        const stock = Number(doubleVar?.stock || 0);

        return (
          <div key={dIdx}>
            <strong>Size:</strong> {doubleVar?.Size?.name} —{" "}
            <strong>Stock:</strong> {stock}
            {stock === 0 ? (
              <span className="text-danger ms-2 fw-bold">(No Stock)</span>
            ) : stock < lowStockLimit ? (
              <span className="text-warning ms-2 fw-bold">(Low)</span>
            ) : null}
          </div>
        );
      }

      // TRIPLE
      return doubleVar.Triple_Variants.map((tripleVar, tIdx) => {
        const stock = Number(tripleVar?.stock || 0);

        return (
          <div key={`${dIdx}-${tIdx}`}>
            <strong>Diamond:</strong> {tripleVar?.Diamond?.name},{" "}
            <strong>Size:</strong> {doubleVar?.Size?.name} —{" "}
            <strong>Stock:</strong> {stock}
            {stock === 0 ? (
              <span className="text-danger ms-2 fw-bold">(No Stock)</span>
            ) : stock < lowStockLimit ? (
              <span className="text-warning ms-2 fw-bold">(Low)</span>
            ) : null}
          </div>
        );
      });
    });
  };
  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Product Stocks"}
          link={"/admin/products/product-stock"}
        />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  <div className="row p-2">
                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className=" d-flex align-items-center mb-3">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1,
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.total,
                            )} of ${data?.data?.total} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className="   col-12">
                        <div className="row align-items-end mb-3">
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                            <div className="num">
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                value={search}
                                placeholder="Search product"
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end ">
                            <div className="Search me-2">
                              <Button
                                type="button"
                                onClick={() => {
                                  setonPageChange(1);
                                  getDataAll();
                                }}
                                className="btn btn-search"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                         
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  setReset(!reset);
                                }}
                                className="btn btn-reset"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            {visible.col1 && (
                              <th className="sr" style={{ width: "50px" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.col2 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Product{" "}
                              </th>
                            )}{" "}
                            {visible.col3 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Purchase Quantity
                              </th>
                            )}{" "}
                            {visible.col4 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Receiving Quantity{" "}
                              </th>
                            )}{" "}
                            {visible.col5 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Sale Quantity{" "}
                              </th>
                            )}{" "}
                            {/* {visible.col6 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Subscription Sale Quantity{" "}
                              </th>
                            )}{" "} */}
                            {/* {visible.col7 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }} 
                              >
                                General Stock Quantity{" "}
                              </th>
                            )}{" "} */}
                            {visible.col8 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Varient name{" "}
                              </th>
                            )}{" "}
                            {visible.col8 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                stock{" "}
                              </th>
                            )}{" "}
                            {/* {visible.col8 && (
                              <th
                                className="tax-name"
                                style={{ width: "100px" }}
                              >
                                Subscription stock{" "}
                              </th>
                            )}{" "} */}
                            {/* { visible.col7 && (
                              <th className="tax-name" style={{ width: "100px" }}>
                                Status
                              </th>
                            )} */}
                            {visible.col9 && (
                              <th className="active" style={{ width: "50px" }}>
                                Action
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.map((product, productIndex) => {
                            const variants = product.Product_Variants || [];
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + productIndex + 1;

                            return variants.map((variant, vIdx) => (
                              <tr
                                key={`product-${productIndex}-variant-${vIdx}`}
                              >
                                {/* Serial Number */}
                                {vIdx === 0 && visible.col1 && (
                                  <td rowSpan={variants.length}>
                                    {paginatedIndex}.
                                  </td>
                                )}

                                {/* Product Name */}
                                {vIdx === 0 && visible.col2 && (
                                  <td rowSpan={variants.length}>
                                    {product?.name}
                                  </td>
                                )}

                                {/* Purchase Order Quantity */}
                                {vIdx === 0 && visible.col3 && (
                                  <td rowSpan={variants.length}>
                                    {product?.Purchase_Order_Products?.reduce(
                                      (total, item) =>
                                        total + Number(item.quantity || 0),
                                      0,
                                    )}
                                  </td>
                                )}

                                {/* Receiving Quantity */}
                                {vIdx === 0 && visible.col4 && (
                                  <td rowSpan={variants.length}>
                                    {product?.Receiving_Products?.reduce(
                                      (total, item) =>
                                        total + Number(item.quantity || 0),
                                      0,
                                    )}
                                  </td>
                                )}

                                {/* Order Detail Quantity */}
                                {vIdx === 0 && visible.col5 && (
                                  <td rowSpan={variants.length}>
                                    {product?.Product_Order_Details?.reduce(
                                      (total, item) =>
                                        total + Number(item.quantity || 0),
                                      0,
                                    )}
                                  </td>
                                )}

                                {/* Variant Name (Multi-Variant handled) */}
                                <td>{renderVariantName(variant)}</td>

                                {/* Variant Stock (Multi-Variant handled) */}
                                <td>
                                  {renderVariantStock(
                                    variant,
                                    Number(appsetup?.low_stock_day),
                                  )}
                                </td>

                                {/* Edit Button */}
                                {vIdx === 0 && visible.col9 && (
                                  <td rowSpan={variants.length}>
                                    {isAllow.includes(
                                      IDS.OfferedProduct.Edit,
                                    ) && (
                                      <EditButton
                                        handleShow1={handleShow1}
                                        id={product?.id}
                                      />
                                    )}
                                  </td>
                                )}
                              </tr>
                            ));
                          })}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Stock Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Array.isArray(selectedItem?.Product_Variants) ? (
            selectedItem.Product_Variants.map((stockItem, index) => (
              <div key={index} className="mb-2">
                <strong>Varient {index + 1}:</strong>
                <div>General Stock: {stockItem.general_stock}</div>
                {/* <div>Subscription Stock: {stockItem.subscription_stock}</div> */}
                {/* Replace above fields with actual keys from your stock item */}
              </div>
            ))
          ) : (
            <div>No data available.</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
